var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelivery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.875C3.5 5.8379 4.3193 5 5.3335 5h4.1769c1.5756 0 2.9794 1.0313 3.4779 2.5664l5.277 16.1836c1.7246.0293 3.2544.873 4.2399 2.168l11.5796-3.9492c.9626-.3282 1.9996.205 2.3205 1.1835s-.2005 2.045-1.1574 2.3731l-11.5796 3.9492C23.6168 32.5332 21.1759 35 18.1679 35c-3.0367 0-5.5005-2.5195-5.5005-5.625 0-1.8047.8308-3.4102 2.12-4.4414L9.5104 8.75h-4.177C4.3195 8.75 3.5 7.9121 3.5 6.875m14.0262 6.0059c-.3152-.9844.2119-2.045 1.1745-2.3614l2.6185-.8672 1.1344 3.5684 3.4894-1.1602-1.1402-3.5683 2.6184-.8672c.9626-.3223 1.9997.2168 2.3091 1.2012l2.8304 8.9179c.3151.9844-.212 2.045-1.1746 2.3614L22.6656 23c-.9625.3223-1.9996-.2168-2.309-1.2012z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelivery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delivery.3fbc2f91f892d4ad194461ef6bc7f2b2.svg";